import * as browserUtils from '@tolk-ai/browser-utils';
import * as genericUtils from '@tolk-ai/generic-utils';

var CreateOneInstagramLoginConfigErrors;

(function (CreateOneInstagramLoginConfigErrors) {
  CreateOneInstagramLoginConfigErrors[CreateOneInstagramLoginConfigErrors["inexistingBot"] = 0] = "inexistingBot";
})(CreateOneInstagramLoginConfigErrors || (CreateOneInstagramLoginConfigErrors = {}));

var GetOneInstagramChannelConfigErrors;

(function (GetOneInstagramChannelConfigErrors) {
  GetOneInstagramChannelConfigErrors[GetOneInstagramChannelConfigErrors["inexistingInstagramChannelConfig"] = 0] = "inexistingInstagramChannelConfig";
})(GetOneInstagramChannelConfigErrors || (GetOneInstagramChannelConfigErrors = {}));

var AuthenticateWithInstagramLoginErrors;

(function (AuthenticateWithInstagramLoginErrors) {
  AuthenticateWithInstagramLoginErrors[AuthenticateWithInstagramLoginErrors["inexistingLoginConfig"] = 0] = "inexistingLoginConfig";
  AuthenticateWithInstagramLoginErrors[AuthenticateWithInstagramLoginErrors["channelPageIdsAlreadyExists"] = 1] = "channelPageIdsAlreadyExists";
})(AuthenticateWithInstagramLoginErrors || (AuthenticateWithInstagramLoginErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuthenticateWithInstagramLoginErrors () { return AuthenticateWithInstagramLoginErrors; },
  get CreateOneInstagramLoginConfigErrors () { return CreateOneInstagramLoginConfigErrors; },
  get GetOneInstagramChannelConfigErrors () { return GetOneInstagramChannelConfigErrors; }
});

const createOneInstagramLoginConfig$2 = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('post', `/v1/bots/${botId}/connectors-config/instagram-login`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingBot') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const getOneInstagramChannelConfig$2 = authenticatedRequest => async botId => {
  try {
    const result = await authenticatedRequest('get', `/v1/bots/${botId}/connectors-config/instagram-login`);
    return result;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error) && error.response.data.error === 'inexistingInstagramChannelConfig') {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestInstagramLoginConfigToInstagramLoginConfig = restInstagramLoginConfig => ({
  botId: restInstagramLoginConfig.botId,
  state: restInstagramLoginConfig.state,
  url: restInstagramLoginConfig.url
});

const convertRestInstagramChannelConfigToInstagramChannelConfig = restInstagramChannelConfig => ({
  botId: restInstagramChannelConfig.botId,
  pagesConfig: restInstagramChannelConfig.pagesConfig,
  userAccessToken: restInstagramChannelConfig.userAccessToken
});

const createOneInstagramLoginConfig$1 = authenticatedRequest => async botId => {
  const result = await createOneInstagramLoginConfig$2(authenticatedRequest)(botId);

  if (result === null) {
    return CreateOneInstagramLoginConfigErrors.inexistingBot;
  }

  return convertRestInstagramLoginConfigToInstagramLoginConfig(result);
};

const getOneInstagramChannelConfig$1 = authenticatedRequest => async botId => {
  const result = await getOneInstagramChannelConfig$2(authenticatedRequest)(botId);

  if (result === null) {
    return GetOneInstagramChannelConfigErrors.inexistingInstagramChannelConfig;
  }

  return convertRestInstagramChannelConfigToInstagramChannelConfig(result);
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOneInstagramLoginConfig: createOneInstagramLoginConfig$1,
  getOneInstagramChannelConfig: getOneInstagramChannelConfig$1
});

const getUserAccessTokenFacebookByCode = (axios, facebookApplicationId, facebookApplicationSecret, redirectUri) => async code => {
  try {
    const result = await axios.get(`https://graph.facebook.com/v12.0/oauth/access_token?client_id=${facebookApplicationId}&redirect_uri=${redirectUri}&client_secret=${facebookApplicationSecret}&code=${code}`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getPagesFacebook = axios => async accesstoken => {
  try {
    const result = await axios.get(`https://graph.facebook.com/v12.0/me/accounts?access_token=${accesstoken}&fields=id%2Cname&limit=999`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getPageAccessTokenFacebookAndInstagramBusinessAccount = axios => async (pageId, userAccessToken) => {
  try {
    const result = await axios.get(`https://graph.facebook.com/${pageId}?fields=access_token,instagram_business_account&access_token=${userAccessToken}`);
    return result.data;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneInstagramChannelConfigByCode = (axios, facebookApplicationId, facebookApplicationSecret, redirectUri) => async (code, botId) => {
  const restAccessToken = await getUserAccessTokenFacebookByCode(axios, facebookApplicationId, facebookApplicationSecret, redirectUri)(code);
  const restPagesFacebook = await getPagesFacebook(axios)(restAccessToken.access_token);
  const pagesConfig = await Promise.all(restPagesFacebook.data.map(async pageFacebook => {
    const pageAccessTokenAndInstagramBusinessAccount = await getPageAccessTokenFacebookAndInstagramBusinessAccount(axios)(pageFacebook.id, restAccessToken.access_token);

    if (typeof pageAccessTokenAndInstagramBusinessAccount.instagram_business_account === 'undefined') {
      return null;
    }

    return {
      accessToken: pageAccessTokenAndInstagramBusinessAccount.access_token,
      id: pageAccessTokenAndInstagramBusinessAccount.instagram_business_account.id,
      name: pageFacebook.name
    };
  }));
  const filteredPagesConfig = pagesConfig.filter(pageConfig => pageConfig !== null);
  return {
    botId,
    pagesConfig: filteredPagesConfig,
    userAccessToken: restAccessToken.access_token
  };
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneInstagramChannelConfigByCode: getOneInstagramChannelConfigByCode
});

const getOneMongoBotByBotId = mongodb => async botId => mongodb.collection('api_bots').findOne({
  bot_id: botId
});

const convertMongodbBotToBot = mongodbBot => ({
  id: mongodbBot.bot_id
});

const getOneBotByBotId = mongodb => async botId => {
  const result = await getOneMongoBotByBotId(mongodb)(botId);

  if (result === null) {
    return null;
  }

  return convertMongodbBotToBot(result);
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOneBotByBotId: getOneBotByBotId
});

const saveOnePgInstagramLoginConfig = pool => async instagramLoginConfig => {
  try {
    await pool.query(`INSERT INTO instagram_login_config(
          bot_id,
          state,
          url
        )
        VALUES ($1, $2, $3)
        ON CONFLICT (bot_id)
        DO UPDATE SET
        state=$2,
        url=$3;`, [instagramLoginConfig.botId, instagramLoginConfig.state, instagramLoginConfig.url]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgInstagramLoginConfigByState = pool => async state => {
  var _a;

  try {
    const result = await pool.query(`SELECT
          bot_id,
          url,
          state
        FROM instagram_login_config
        WHERE state = $1;`, [state]);
    return (_a = result.rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgInstagramChannelConfigByBotId = pool => async botId => {
  try {
    const result = (await pool.query(`SELECT
        "instagram_channel_config".id,
        "instagram_channel_config".bot_id,
        "instagram_channel_config".user_access_token,
        "instagram_page_config"."name",
        "instagram_page_config".access_token
      FROM instagram_channel_config
      INNER JOIN instagram_page_config
      ON "instagram_page_config".instagram_channel_config_id = "instagram_channel_config".id
      WHERE bot_id = $1;`, [botId])).rows;

    if (genericUtils.isEmpty(result)) {
      return null;
    }

    return result;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOnePgInstagramLoginConfigByBotId = pool => async botId => {
  try {
    await pool.query(`DELETE FROM instagram_login_config WHERE bot_id = $1;`, [botId]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const convertPgInstagramLoginConfigToInstagramLoginConfig = pgInstagramLoginConfig => ({
  botId: pgInstagramLoginConfig.bot_id,
  state: pgInstagramLoginConfig.state,
  url: pgInstagramLoginConfig.url
});

const convertPgInstagramChannelAndPagesConfigToInstagramChannelConfig = pgInstagramChannelAndPagesConfig => ({
  botId: pgInstagramChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].bot_id,
  pagesConfig: pgInstagramChannelAndPagesConfig.map(pgInstagramPageConfig => ({
    accessToken: pgInstagramPageConfig.access_token,
    id: pgInstagramChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].id.toString(),
    name: pgInstagramPageConfig.name
  })),
  userAccessToken: pgInstagramChannelAndPagesConfig[genericUtils.ARRAY.FIRST_INDEX].user_access_token
});

const saveOneInstagramLoginConfig = pool => async instagramLoginConfig => {
  await saveOnePgInstagramLoginConfig(pool)(instagramLoginConfig);
};

const getOneInstagramLoginConfigByState = pool => async state => {
  const pgInstagramLoginConfig = await getOnePgInstagramLoginConfigByState(pool)(state);

  if (pgInstagramLoginConfig === null) {
    return null;
  }

  return convertPgInstagramLoginConfigToInstagramLoginConfig(pgInstagramLoginConfig);
};

const getOneInstagramChannelConfigByBotId = pool => async botId => {
  const pgInstagramChannelAndPagesConfig = await getOnePgInstagramChannelConfigByBotId(pool)(botId);

  if (pgInstagramChannelAndPagesConfig === null) {
    return null;
  }

  return convertPgInstagramChannelAndPagesConfigToInstagramChannelConfig(pgInstagramChannelAndPagesConfig);
};

const deleteOneInstagramLoginConfigByBotId = pool => async botId => {
  await deleteOnePgInstagramLoginConfigByBotId(pool)(botId);
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteOneInstagramLoginConfigByBotId: deleteOneInstagramLoginConfigByBotId,
  getOneInstagramChannelConfigByBotId: getOneInstagramChannelConfigByBotId,
  getOneInstagramLoginConfigByState: getOneInstagramLoginConfigByState,
  saveOneInstagramLoginConfig: saveOneInstagramLoginConfig
});

var SaveOneInstagramChannelConfigErrors;

(function (SaveOneInstagramChannelConfigErrors) {
  SaveOneInstagramChannelConfigErrors[SaveOneInstagramChannelConfigErrors["channelPageIdsAlreadyExists"] = 0] = "channelPageIdsAlreadyExists";
})(SaveOneInstagramChannelConfigErrors || (SaveOneInstagramChannelConfigErrors = {}));

var infrastructurePorts = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get SaveOneInstagramChannelConfigErrors () { return SaveOneInstagramChannelConfigErrors; }
});

const saveOnePgInstagramChannelConfig = pool => async instagramChannelConfig => {
  try {
    await pool.query(`INSERT INTO instagram_channel_config(
        bot_id,
        user_access_token
      )
      VALUES ($1, $2)
      ON CONFLICT (bot_id) DO UPDATE SET
      bot_id=$1,
      user_access_token=$2;`, [instagramChannelConfig.botId, instagramChannelConfig.userAccessToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOnePgInstagramPageConfig = pool => async (pageConfig, botId) => {
  try {
    await pool.query(`INSERT INTO instagram_page_config(
          instagram_channel_config_id,
          name,
          access_token,
          page_id
        )
        VALUES ((SELECT "instagram_channel_config".id FROM instagram_channel_config WHERE "instagram_channel_config".bot_id = $1), $2, $3, $4);`, [botId, pageConfig.name, pageConfig.accessToken, pageConfig.id]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getManyPgPagesConfigByBotId = pool => async botId => {
  try {
    const result = await pool.query(`
        SELECT * FROM instagram_page_config
        WHERE instagram_channel_config_id = (SELECT "instagram_channel_config".id FROM instagram_channel_config WHERE "instagram_channel_config".bot_id = $1)
      `, [botId]);
    return result.rows;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveManyPgInstagramPageConfig = pool => async (instagramPagesConfig, botId) => {
  await Promise.all(instagramPagesConfig.map(async pageConfig => saveOnePgInstagramPageConfig(pool)(pageConfig, botId)));
};

const deleteOnePgInstagramPagesConfig = pool => async pgInstagramPageConfig => {
  try {
    await pool.query(`
      DELETE FROM instagram_page_config
      WHERE page_id = $1
      AND instagram_channel_config_id = $2
    `, [pgInstagramPageConfig.page_id, pgInstagramPageConfig.instagram_channel_config_id]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteManyPgInstagramPagesConfig = pool => async pgInstagramPagesConfig => {
  await Promise.all(pgInstagramPagesConfig.map(async pgInstagramPageConfig => {
    await deleteOnePgInstagramPagesConfig(pool)(pgInstagramPageConfig);
  }));
};

const findManyMongodbInstagramChannels = mongodb => async (botId, pagesConfigToDelete) => {
  try {
    const mongoInstagramChannels = await mongodb.collection('api_channels').find({
      bot_id: botId,
      'options.pageId': {
        $in: pagesConfigToDelete
      },
      slug: 'instagram'
    }, {
      projection: {
        _id: 1
      }
    }).toArray();
    return mongoInstagramChannels.map(mongoInstagramChannel => mongoInstagramChannel._id);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateManyMongodbInstagramChannels = mongodb => async channelIds => {
  try {
    await mongodb.collection('api_channels').updateMany({
      _id: {
        $in: channelIds
      },
      slug: 'instagram'
    }, {
      $set: {
        isActivate: false
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateChannelsMongodbBot = mongodb => async (botId, channelIds) => {
  try {
    await mongodb.collection('api_bots').updateOne({
      bot_id: botId
    }, {
      $pull: {
        channels: {
          $in: channelIds
        }
      }
    });
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const updateManyMongodbInstagramChannelByBotId = mongodb => async (botId, pgIntagramPagesConfig) => {
  const pageIds = pgIntagramPagesConfig.map(pgIntagramPageConfig => pgIntagramPageConfig.page_id);
  const mongodbChannelIds = await findManyMongodbInstagramChannels(mongodb)(botId, pageIds);
  await updateManyMongodbInstagramChannels(mongodb)(mongodbChannelIds);
  await updateChannelsMongodbBot(mongodb)(botId, mongodbChannelIds);
};

const getPagesConfigToDelete = (pgPagesConfig, instagramChannelConfig) => {
  const pagesConfigId = new Set(instagramChannelConfig.pagesConfig.map(pageConfig => pageConfig.id));
  return pgPagesConfig.map(pgPageConfig => {
    if (pagesConfigId.has(pgPageConfig.page_id)) {
      return null;
    }

    return pgPageConfig;
  }).filter(value => value !== null);
};

const getPagesConfigToAdd = (pgPagesConfig, instagramChannelConfig) => {
  const pgPagesConfigId = new Set(pgPagesConfig.map(pgPageConfig => pgPageConfig.page_id));
  return instagramChannelConfig.pagesConfig.map(pageConfig => {
    if (pgPagesConfigId.has(pageConfig.id)) {
      return null;
    }

    return pageConfig;
  }).filter(value => value !== null);
};

const convertPageConfigsToRestInstagramChannels = pageConfigs => ({
  channels: pageConfigs.map(pageConfig => ({
    name: pageConfig.name,
    options: {
      pageId: pageConfig.id,
      pageToken: pageConfig.accessToken
    },
    slug: 'instagram'
  }))
});

const saveManyAxiosInstagramChannels = axiosBotManagment => async (restInstagramChannels, botId) => {
  try {
    await axiosBotManagment.post(`/v1/bots/${botId}/channels`, restInstagramChannels);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const isChannelPageIdAlreadyExistsForAnotherBot = mongodb => async (pagesConfig, botId) => {
  try {
    const pagesConfigId = pagesConfig.map(pageConfig => pageConfig.id);
    const mongoInstagramChannels = await mongodb.collection('api_channels').find({
      bot_id: {
        $nin: [botId]
      },
      isActivate: true,
      'options.pageId': {
        $in: pagesConfigId
      },
      slug: 'instagram'
    }).toArray();
    return !genericUtils.isEmpty(mongoInstagramChannels);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOneInstagramChannelConfig = (pool, axiosInstanceBotManagement, mongodb) => async instagramChannelConfig => {
  if (await isChannelPageIdAlreadyExistsForAnotherBot(mongodb)(instagramChannelConfig.pagesConfig, instagramChannelConfig.botId)) {
    return SaveOneInstagramChannelConfigErrors.channelPageIdsAlreadyExists;
  }

  const pgPagesConfig = await getManyPgPagesConfigByBotId(pool)(instagramChannelConfig.botId);
  const pagesConfigToDelete = getPagesConfigToDelete(pgPagesConfig, instagramChannelConfig);
  const pagesConfigToAdd = getPagesConfigToAdd(pgPagesConfig, instagramChannelConfig);

  if (pagesConfigToDelete.length > genericUtils.ARRAY.EMPTY_LENGTH) {
    await updateManyMongodbInstagramChannelByBotId(mongodb)(instagramChannelConfig.botId, pagesConfigToDelete);
    await deleteManyPgInstagramPagesConfig(pool)(pagesConfigToDelete);
  }

  await saveOnePgInstagramChannelConfig(pool)(instagramChannelConfig);
  await saveManyPgInstagramPageConfig(pool)(pagesConfigToAdd, instagramChannelConfig.botId);
  const restInstagramChannels = convertPageConfigsToRestInstagramChannels(pagesConfigToAdd);
  await saveManyAxiosInstagramChannels(axiosInstanceBotManagement)(restInstagramChannels, instagramChannelConfig.botId);
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  saveOneInstagramChannelConfig: saveOneInstagramChannelConfig
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	RestInstagramLoginConfig: {
		type: "object",
		properties: {
			botId: {
				type: "string"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"botId",
			"state",
			"url"
		],
		additionalProperties: false
	},
	RestPageConfig: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"accessToken"
		],
		additionalProperties: false
	},
	RestInstagramChannelConfig: {
		type: "object",
		properties: {
			userAccessToken: {
				type: "string"
			},
			pagesConfig: {
				type: "array",
				items: {
					$ref: "#/definitions/RestPageConfig"
				}
			},
			botId: {
				type: "string"
			}
		},
		required: [
			"userAccessToken",
			"pagesConfig",
			"botId"
		],
		additionalProperties: false
	},
	BotId: {
		type: "string"
	},
	Bot: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	State: {
		type: "string"
	},
	Code: {
		type: "string"
	},
	PageConfig: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			accessToken: {
				type: "string"
			}
		},
		required: [
			"id",
			"name",
			"accessToken"
		],
		additionalProperties: false
	},
	InstagramLoginConfig: {
		type: "object",
		properties: {
			botId: {
				$ref: "#/definitions/BotId"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"botId",
			"state",
			"url"
		],
		additionalProperties: false
	},
	InstagramChannelConfig: {
		type: "object",
		properties: {
			userAccessToken: {
				type: "string"
			},
			pagesConfig: {
				type: "array",
				items: {
					$ref: "#/definitions/PageConfig"
				}
			},
			botId: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"userAccessToken",
			"pagesConfig",
			"botId"
		],
		additionalProperties: false
	},
	RestUserAccessToken: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			token_type: {
				type: "string"
			},
			expires_in: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"token_type",
			"expires_in"
		],
		additionalProperties: false
	},
	InstagramBusinessAccount: {
		type: "object",
		properties: {
			id: {
				type: "string"
			}
		},
		required: [
			"id"
		],
		additionalProperties: false
	},
	RestPageAccessTokenAndInstagramBusinessAccount: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			instagram_business_account: {
				$ref: "#/definitions/InstagramBusinessAccount"
			},
			id: {
				type: "string"
			}
		},
		required: [
			"access_token",
			"id"
		],
		additionalProperties: false
	},
	PageFacebook: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			name: {
				type: "string"
			}
		},
		required: [
			"id",
			"name"
		],
		additionalProperties: false
	},
	RestPagesFacebook: {
		type: "object",
		properties: {
			data: {
				type: "array",
				items: {
					$ref: "#/definitions/PageFacebook"
				}
			}
		},
		required: [
			"data"
		],
		additionalProperties: false
	},
	MongoBot: {
		type: "object",
		properties: {
			bot_id: {
				$ref: "#/definitions/BotId"
			}
		},
		required: [
			"bot_id"
		],
		additionalProperties: false
	},
	PgInstagramChannelConfigId: {
		type: "string"
	},
	PgInstagramChannelConfig: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/PgInstagramChannelConfigId"
			},
			bot_id: {
				type: "string"
			},
			user_access_token: {
				type: "string"
			}
		},
		required: [
			"id",
			"bot_id",
			"user_access_token"
		],
		additionalProperties: false
	},
	PgInstagramPageConfig: {
		type: "object",
		properties: {
			instagram_channel_config_id: {
				type: "string"
			},
			name: {
				type: "string"
			},
			access_token: {
				type: "string"
			}
		},
		required: [
			"instagram_channel_config_id",
			"name",
			"access_token"
		],
		additionalProperties: false
	},
	PgInstagramPagesConfig: {
		type: "array",
		items: {
			$ref: "#/definitions/PgInstagramPageConfig"
		}
	},
	MongodbChannelId: {
		type: "string"
	},
	MongodbChannelIds: {
		type: "array",
		items: {
			$ref: "#/definitions/MongodbChannelId"
		}
	},
	MongodbInstagramChannelOptions: {
		type: "object",
		properties: {
			pageId: {
				type: "string"
			},
			pageToken: {
				type: "string"
			}
		},
		required: [
			"pageId",
			"pageToken"
		],
		additionalProperties: false
	},
	MongodbInstagramChannel: {
		type: "object",
		properties: {
			_id: {
				type: "string"
			},
			slug: {
				type: "string",
				"const": "instagram"
			},
			bot_id: {
				type: "string"
			},
			isActivate: {
				type: "boolean"
			},
			options: {
				$ref: "#/definitions/MongodbInstagramChannelOptions"
			}
		},
		required: [
			"_id",
			"slug",
			"bot_id",
			"isActivate",
			"options"
		],
		additionalProperties: false
	},
	MongodbInstagramChannels: {
		type: "array",
		items: {
			$ref: "#/definitions/MongodbInstagramChannel"
		}
	},
	MongodbBot: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			channels: {
				$ref: "#/definitions/MongodbChannelIds"
			}
		},
		required: [
			"bot_id",
			"channels"
		],
		additionalProperties: false
	},
	RestInstagramChannel: {
		type: "object",
		properties: {
			name: {
				type: "string"
			},
			slug: {
				type: "string",
				"const": "instagram"
			},
			options: {
				type: "object",
				properties: {
					pageId: {
						type: "string"
					},
					pageToken: {
						type: "string"
					}
				},
				required: [
					"pageId",
					"pageToken"
				],
				additionalProperties: false
			}
		},
		required: [
			"name",
			"slug",
			"options"
		],
		additionalProperties: false
	},
	RestInstagramChannels: {
		type: "object",
		properties: {
			channels: {
				type: "array",
				items: {
					$ref: "#/definitions/RestInstagramChannel"
				}
			}
		},
		required: [
			"channels"
		],
		additionalProperties: false
	},
	PgInstagramLoginConfig: {
		type: "object",
		properties: {
			bot_id: {
				type: "string"
			},
			state: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"bot_id",
			"state",
			"url"
		],
		additionalProperties: false
	},
	PgInstagramChannelAndPagesConfig: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/PgInstagramChannelConfigId"
			},
			bot_id: {
				type: "string"
			},
			user_access_token: {
				type: "string"
			},
			name: {
				type: "string"
			},
			access_token: {
				type: "string"
			}
		},
		required: [
			"id",
			"bot_id",
			"user_access_token",
			"name",
			"access_token"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $schema: $schema,
  definitions: definitions,
  'default': entitiesSchemas
});

const generateUrl = (botManagementExpressRedirectUrl, facebookApplicationId, state) => `https://www.facebook.com/dialog/oauth?response_type=code%20granted_scopes&display=popup&client_id=${facebookApplicationId}&redirect_uri=${botManagementExpressRedirectUrl}&state=${state}&scope=instagram_manage_messages%2Cpages_manage_metadata%2Cinstagram_basic`;

const instagramLoginConfigFactory = (botManagementExpressRedirectUrl, facebookApplicationId) => botId => {
  const state = genericUtils.generateRandomString();
  return {
    botId,
    state,
    url: generateUrl(botManagementExpressRedirectUrl, facebookApplicationId, state)
  };
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  instagramLoginConfigFactory: instagramLoginConfigFactory
});

const createOneInstagramLoginConfig = (getOneBotByBotId, instagramLoginConfigFactory, saveOneInstagramLoginConfig) => async botId => {
  const bot = await getOneBotByBotId(botId);

  if (!bot) {
    return CreateOneInstagramLoginConfigErrors.inexistingBot;
  }

  const instagramLoginConfig = instagramLoginConfigFactory(botId);
  await saveOneInstagramLoginConfig(instagramLoginConfig);
  return instagramLoginConfig;
};

const getOneInstagramChannelConfig = getOneInstagramChannelConfigByBotId => async botId => {
  const instagramChannelConfig = await getOneInstagramChannelConfigByBotId(botId);

  if (instagramChannelConfig === null) {
    return GetOneInstagramChannelConfigErrors.inexistingInstagramChannelConfig;
  }

  return instagramChannelConfig;
};

const authenticateWithInstagramLogin = (getOneInstagramLoginConfigByState, getOneInstagramChannelConfigByCode, saveOneInstagramChannelConfig, deleteOneInstagramLoginConfigByBotId) => async (state, code) => {
  const loginConfig = await getOneInstagramLoginConfigByState(state);

  if (loginConfig === null) {
    return AuthenticateWithInstagramLoginErrors.inexistingLoginConfig;
  }

  const channelConfig = await getOneInstagramChannelConfigByCode(code, loginConfig.botId);
  const saveInstagramChannelConfig = await saveOneInstagramChannelConfig(channelConfig);
  await deleteOneInstagramLoginConfigByBotId(loginConfig.botId);

  if (saveInstagramChannelConfig === SaveOneInstagramChannelConfigErrors.channelPageIdsAlreadyExists) {
    return AuthenticateWithInstagramLoginErrors.channelPageIdsAlreadyExists;
  }

  return channelConfig;
};

export { applicationPorts as appPorts, authenticateWithInstagramLogin, index$4 as axiosBotsRepository, index$5 as axiosInstagram, index as botModel, createOneInstagramLoginConfig, entitiesSchemas$1 as entitiesSchemas, getOneInstagramChannelConfig, infrastructurePorts as infraPorts, index$3 as mongodbBotsRepository, index$1 as postgresqlAxiosMongodbBotsRepository, index$2 as postgresqlBotsRepository };
